//数据
export default {
	
	systemData:{},
	Login:{},
	Query:{},
	Search:{}
	
	
}


// WEBPACK FOOTER //
// ./src/store/state.js